// Footer.js
import React from 'react';

// Add your social media logos (icons). You can either use image URLs or SVG icons.
const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2024 राष्ट्रीय युवा मोर्चा | सभी अधिकार सुरक्षित</p>
            <div className="social-links">
                <a href="https://www.facebook.com/RashtriyaYuvaMorcha.in" target="_blank" rel="noopener noreferrer">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Facebook_f_logo_%282019%29.svg/1024px-Facebook_f_logo_%282019%29.svg.png" alt="Facebook" className="social-icon" />
                </a>
                <a href="https://www.instagram.com/rashtriyayuvamorcha" target="_blank" rel="noopener noreferrer">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Instagram_logo_2022.svg/1024px-Instagram_logo_2022.svg.png" alt="Instagram" className="social-icon" />
                </a>
            </div>
        </footer>
    );
};

export default Footer;
